import { customScrollMinimal, Drawer } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledDrawer = styled(Drawer)`
  ${Drawer.Styled.Header} {
    background-color: var(--background-default);
  }

  ${Drawer.Styled.Container} {
    width: 788px;
  }
`;

export const ContentWrapper = styled.div`
  width: 100%;
  padding: 20px;
  ${customScrollMinimal};
`;
